var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixFormsV4Submission from '@wix/ambassador-forms-v4-submission/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["UNKNOWN_SUBMISSION_STATUS"] = "UNKNOWN_SUBMISSION_STATUS";
    SubmissionStatus["PENDING"] = "PENDING";
    SubmissionStatus["CONFIRMED"] = "CONFIRMED";
    SubmissionStatus["PAYMENT_WAITING"] = "PAYMENT_WAITING";
    SubmissionStatus["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
})(SubmissionStatus || (SubmissionStatus = {}));
export var OptInLevel;
(function (OptInLevel) {
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var RequiredIndicator;
(function (RequiredIndicator) {
    RequiredIndicator["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
    /** Asterisk (*). */
    RequiredIndicator["ASTERISK"] = "ASTERISK";
    /** Text (default: "Required"). */
    RequiredIndicator["TEXT"] = "TEXT";
    /** None. */
    RequiredIndicator["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
export var RequiredIndicatorPlacement;
(function (RequiredIndicatorPlacement) {
    RequiredIndicatorPlacement["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
    /** After field title. */
    RequiredIndicatorPlacement["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
    /** Before field title. */
    RequiredIndicatorPlacement["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
export var Format;
(function (Format) {
    Format["UNDEFINED"] = "UNDEFINED";
    Format["DATE"] = "DATE";
    Format["TIME"] = "TIME";
    Format["DATE_TIME"] = "DATE_TIME";
    Format["EMAIL"] = "EMAIL";
    Format["URL"] = "URL";
    Format["UUID"] = "UUID";
    Format["PHONE"] = "PHONE";
    Format["URI"] = "URI";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
export var ValidationFormat;
(function (ValidationFormat) {
    ValidationFormat["UNDEFINED"] = "UNDEFINED";
    /** File upload validation. */
    ValidationFormat["WIX_FILE"] = "WIX_FILE";
    /** Payment validation. */
    ValidationFormat["PAYMENT"] = "PAYMENT";
    /** Multiline address. */
    ValidationFormat["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(ValidationFormat || (ValidationFormat = {}));
export var ProductType;
(function (ProductType) {
    ProductType["UNKNOWN"] = "UNKNOWN";
    /** Shippable (physical). */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    PriceType["UNKNOWN"] = "UNKNOWN";
    /** Fixed price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Dynamic price from price range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var FormatEnumFormat;
(function (FormatEnumFormat) {
    FormatEnumFormat["UNDEFINED"] = "UNDEFINED";
    FormatEnumFormat["DATE"] = "DATE";
    FormatEnumFormat["TIME"] = "TIME";
    FormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    FormatEnumFormat["EMAIL"] = "EMAIL";
    FormatEnumFormat["URL"] = "URL";
    FormatEnumFormat["UUID"] = "UUID";
    FormatEnumFormat["PHONE"] = "PHONE";
    FormatEnumFormat["URI"] = "URI";
    FormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    FormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    FormatEnumFormat["CURRENCY"] = "CURRENCY";
    FormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    FormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FormatEnumFormat || (FormatEnumFormat = {}));
export var StringComponentType;
(function (StringComponentType) {
    StringComponentType["UNKNOWN"] = "UNKNOWN";
    StringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    StringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    StringComponentType["DROPDOWN"] = "DROPDOWN";
    StringComponentType["DATE_TIME"] = "DATE_TIME";
    StringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
})(StringComponentType || (StringComponentType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var ButtonDataType;
(function (ButtonDataType) {
    /** Regular link button */
    ButtonDataType["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    ButtonDataType["ACTION"] = "ACTION";
})(ButtonDataType || (ButtonDataType = {}));
export var LinkTarget;
(function (LinkTarget) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    LinkTarget["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    LinkTarget["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    LinkTarget["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    LinkTarget["TOP"] = "TOP";
})(LinkTarget || (LinkTarget = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var DateFormatPart;
(function (DateFormatPart) {
    DateFormatPart["YEAR"] = "YEAR";
    DateFormatPart["MONTH"] = "MONTH";
    DateFormatPart["DAY"] = "DAY";
})(DateFormatPart || (DateFormatPart = {}));
export var FirstDayOfWeek;
(function (FirstDayOfWeek) {
    FirstDayOfWeek["MONDAY"] = "MONDAY";
    FirstDayOfWeek["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeek || (FirstDayOfWeek = {}));
export var DateTimeInputType;
(function (DateTimeInputType) {
    DateTimeInputType["UNKNOWN"] = "UNKNOWN";
    /** Show date and time input */
    DateTimeInputType["DATE_TIME"] = "DATE_TIME";
    /** Show only date input */
    DateTimeInputType["DATE"] = "DATE";
    /** Show only time input */
    DateTimeInputType["TIME"] = "TIME";
    /** Show date picker input */
    DateTimeInputType["DATE_PICKER"] = "DATE_PICKER";
})(DateTimeInputType || (DateTimeInputType = {}));
export var NumberComponentType;
(function (NumberComponentType) {
    NumberComponentType["UNKNOWN"] = "UNKNOWN";
    NumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    NumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
export var BooleanComponentType;
(function (BooleanComponentType) {
    BooleanComponentType["UNKNOWN"] = "UNKNOWN";
    BooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
export var ItemType;
(function (ItemType) {
    ItemType["UNKNOWN"] = "UNKNOWN";
    ItemType["STRING"] = "STRING";
    ItemType["NUMBER"] = "NUMBER";
    ItemType["BOOLEAN"] = "BOOLEAN";
    ItemType["INTEGER"] = "INTEGER";
    ItemType["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
export var PropertiesTypePropertiesType;
(function (PropertiesTypePropertiesType) {
    PropertiesTypePropertiesType["UNKNOWN"] = "UNKNOWN";
    PropertiesTypePropertiesType["STRING"] = "STRING";
    PropertiesTypePropertiesType["NUMBER"] = "NUMBER";
    PropertiesTypePropertiesType["BOOLEAN"] = "BOOLEAN";
    PropertiesTypePropertiesType["INTEGER"] = "INTEGER";
    PropertiesTypePropertiesType["ARRAY"] = "ARRAY";
})(PropertiesTypePropertiesType || (PropertiesTypePropertiesType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["UNKNOWN"] = "UNKNOWN";
    ComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
})(ComponentType || (ComponentType = {}));
export var WixFileComponentType;
(function (WixFileComponentType) {
    WixFileComponentType["UNKNOWN"] = "UNKNOWN";
    WixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    WixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(WixFileComponentType || (WixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    UploadFileFormat["UNDEFINED"] = "UNDEFINED";
    /** Video files */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
    /** Archive files */
    UploadFileFormat["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormat || (UploadFileFormat = {}));
export var PaymentComponentType;
(function (PaymentComponentType) {
    PaymentComponentType["UNKNOWN"] = "UNKNOWN";
    PaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    PaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
})(PaymentComponentType || (PaymentComponentType = {}));
export var NumberOfColumns;
(function (NumberOfColumns) {
    NumberOfColumns["UNKNOWN"] = "UNKNOWN";
    NumberOfColumns["ONE"] = "ONE";
    NumberOfColumns["TWO"] = "TWO";
    NumberOfColumns["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
export var MultilineAddressComponentType;
(function (MultilineAddressComponentType) {
    MultilineAddressComponentType["UNKNOWN"] = "UNKNOWN";
    MultilineAddressComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(MultilineAddressComponentType || (MultilineAddressComponentType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
    /** Country will be determined by customer's IP address. */
    Type["BY_IP"] = "BY_IP";
    /** Pre-selected default country. */
    Type["COUNTRY"] = "COUNTRY";
})(Type || (Type = {}));
export var InputType;
(function (InputType) {
    InputType["UNKNOWN"] = "UNKNOWN";
    InputType["STRING"] = "STRING";
    InputType["NUMBER"] = "NUMBER";
    InputType["BOOLEAN"] = "BOOLEAN";
    InputType["ARRAY"] = "ARRAY";
    InputType["OBJECT"] = "OBJECT";
    InputType["WIX_FILE"] = "WIX_FILE";
    InputType["PAYMENT"] = "PAYMENT";
    InputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(InputType || (InputType = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    Tag["UNTAGGED"] = "UNTAGGED";
    Tag["HOME"] = "HOME";
})(Tag || (Tag = {}));
export var SubscriptionInfoOptInLevel;
(function (SubscriptionInfoOptInLevel) {
    SubscriptionInfoOptInLevel["UNKNOWN"] = "UNKNOWN";
    SubscriptionInfoOptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    SubscriptionInfoOptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(SubscriptionInfoOptInLevel || (SubscriptionInfoOptInLevel = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNDEFINED"] = "UNDEFINED";
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    ContactField["LAST_NAME"] = "LAST_NAME";
    ContactField["COMPANY"] = "COMPANY";
    ContactField["POSITION"] = "POSITION";
    ContactField["EMAIL"] = "EMAIL";
    ContactField["PHONE"] = "PHONE";
    ContactField["ADDRESS"] = "ADDRESS";
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var Target;
(function (Target) {
    Target["UNDEFINED"] = "UNDEFINED";
    /** Opened in same browser tab */
    Target["SELF"] = "SELF";
    /** Url open in new tab */
    Target["BLANK"] = "BLANK";
})(Target || (Target = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN"] = "UNKNOWN";
    FieldType["INPUT"] = "INPUT";
    FieldType["DISPLAY"] = "DISPLAY";
    FieldType["SUBMIT"] = "SUBMIT";
})(FieldType || (FieldType = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    OverrideEntityType["FIELD"] = "FIELD";
    OverrideEntityType["FORM"] = "FORM";
    OverrideEntityType["NESTED_FORM_FIELD"] = "NESTED_FORM_FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Kind;
(function (Kind) {
    Kind["REGULAR"] = "REGULAR";
    Kind["EXTENSION"] = "EXTENSION";
})(Kind || (Kind = {}));
export var SpamFilterProtectionLevel;
(function (SpamFilterProtectionLevel) {
    SpamFilterProtectionLevel["UNKNOWN"] = "UNKNOWN";
    /** Spam filter is not used. Form is open for spam submissions. */
    SpamFilterProtectionLevel["NONE"] = "NONE";
    /** Spam filter operates in basic mode. Form is open to high risk of spam submissions. */
    SpamFilterProtectionLevel["BASIC"] = "BASIC";
    /** Spam filter operates in advanced mode. Form is open to low risk of spam submissions. */
    SpamFilterProtectionLevel["ADVANCED"] = "ADVANCED";
})(SpamFilterProtectionLevel || (SpamFilterProtectionLevel = {}));
export var UrlTargetEnumTarget;
(function (UrlTargetEnumTarget) {
    UrlTargetEnumTarget["UNKNOWN_TARGET"] = "UNKNOWN_TARGET";
    /** Open in the same browser tab. */
    UrlTargetEnumTarget["SELF"] = "SELF";
    /** Open in a new browser tab. */
    UrlTargetEnumTarget["BLANK"] = "BLANK";
})(UrlTargetEnumTarget || (UrlTargetEnumTarget = {}));
export var SubmitSuccessAction;
(function (SubmitSuccessAction) {
    SubmitSuccessAction["UNKNOWN_SUBMIT_SUCCESS_ACTION"] = "UNKNOWN_SUBMIT_SUCCESS_ACTION";
    /** No action will be taken after submission. */
    SubmitSuccessAction["NO_ACTION"] = "NO_ACTION";
    /** A thank you message will be shown after submission. */
    SubmitSuccessAction["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
    /** The user will be redirected to a URL after submission. */
    SubmitSuccessAction["REDIRECT"] = "REDIRECT";
})(SubmitSuccessAction || (SubmitSuccessAction = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    /** Existing or new contact */
    IdentityType["CONTACT"] = "CONTACT";
    /** Member is logged in, matching logic skipped */
    IdentityType["MEMBER"] = "MEMBER";
    /** Matching contact is a member, Merge logic won't be applied */
    IdentityType["NOT_AUTHENTICATED_MEMBER"] = "NOT_AUTHENTICATED_MEMBER";
})(IdentityType || (IdentityType = {}));
const __Array = {
    checkboxGroupOptions: '_checkboxGroup',
    validation: '_inputFieldArrayType',
};
const __Boolean = { checkboxOptions: '_checkbox' };
const __Number = {
    numberInputOptions: '_numberInput',
    ratingInputOptions: '_ratingInput',
};
const __Object = { object: '_inputFieldObjectType' };
const __String = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
    dateTimeOptions: '_dateTimeInput',
    phoneInputOptions: '_phoneInput',
};
const _arrayItems = { object: '_objectType' };
const _arrayType = { items: '_arrayItems' };
const _arrayTypeArrayItems = { objectOptions: '_inputFieldObjectType' };
const _breakPoint = { items: '_itemLayout' };
const _bulkCreateSubmissionBySubmitterRequest = {};
const _bulkCreateSubmissionBySubmitterResponse = {};
const _bulkDeleteSubmissionRequest = {};
const _bulkDeleteSubmissionResponse = {};
const _bulkMarkSubmissionsAsSeenRequest = {};
const _bulkMarkSubmissionsAsSeenResponse = {};
const _bulkRemoveSubmissionFromTrashBinRequest = {};
const _bulkRemoveSubmissionFromTrashBinResponse = {};
const _checkbox = { label: '_richContent' };
const _checkboxGroup = { description: '_richContent', options: '_option' };
const _confirmSubmissionRequest = {};
const _confirmSubmissionResponse = {};
const _countDeletedSubmissionsRequest = {};
const _countDeletedSubmissionsResponse = {};
const _countSubmissionsByFilterRequest = {};
const _countSubmissionsByFilterResponse = {};
const _countSubmissionsRequest = {};
const _countSubmissionsResponse = {};
const _createCheckoutFromSubmissionRequest = { form: '_form' };
const _createCheckoutFromSubmissionResponse = {};
const _createSubmissionBySubmitterRequest = {};
const _createSubmissionBySubmitterResponse = {};
const _createSubmissionRequest = {};
const _createSubmissionResponse = {};
const _dateTimeInput = { description: '_richContent' };
const _deleteSubmissionRequest = {};
const _deleteSubmissionResponse = {};
const _displayField = { header: '_header', richText: '_richText' };
const _donationInput = { description: '_richContent' };
const _dropdown = { description: '_richContent' };
const _fileUpload = { description: '_richContent' };
const _form = {
    fields: '_formField',
    fieldsV2: '_formFieldV2',
    steps: '_step',
    deletedFields: '_formField',
    deletedFieldsV2: '_formFieldV2',
    nestedForms: '_nestedForm',
    submitSettings: '_submitSettings',
};
const _formField = { validation: '_validation' };
const _formFieldV2 = {
    inputOptions: '_inputField',
    displayOptions: '_displayField',
    submitOptions: '_submitButton',
};
const _formLayout = {
    large: '_breakPoint',
    medium: '_breakPoint',
    small: '_breakPoint',
};
const _getDeletedSubmissionRequest = {};
const _getDeletedSubmissionResponse = {};
const _getMediaUploadURLRequest = {};
const _getMediaUploadURLResponse = {};
const _getSubmissionByCheckoutIdRequest = {};
const _getSubmissionByCheckoutIdResponse = {};
const _getSubmissionRequest = {};
const _getSubmissionResponse = {};
const _group = { items: '_itemLayout' };
const _header = { content: '_richContent' };
const _inputField = {
    stringOptions: '__String',
    numberOptions: '__Number',
    booleanOptions: '__Boolean',
    arrayOptions: '__Array',
    objectOptions: '__Object',
    wixFileOptions: '_wixFile',
    paymentOptions: '_payment',
    multilineAddressOptions: '_inputFieldMultilineAddress',
};
const _inputFieldArrayType = { items: '_arrayTypeArrayItems' };
const _inputFieldMultilineAddress = {
    multilineAddressOptions: '_multilineAddress',
};
const _inputFieldObjectType = { properties: 'Map#_objectTypePropertiesType' };
const _isFormSubmittableRequest = {};
const _isFormSubmittableResponse = {};
const _itemLayout = { group: '_group' };
const _listDeletedSubmissionsRequest = {};
const _listDeletedSubmissionsResponse = {};
const _mediaItem = { image: 'wix.common.Image' };
const _multilineAddress = { description: '_richContent' };
const _nestedForm = { form: '_form' };
const _node = { nodes: '_node' };
const _numberInput = { description: '_richContent' };
const _objectType = { properties: 'Map#_propertiesType' };
const _objectTypePropertiesType = { arrayOptions: '_inputFieldArrayType' };
const _option = { media: '_mediaItem' };
const _payment = {
    checkboxGroupOptions: '_productCheckboxGroup',
    donationInputOptions: '_donationInput',
};
const _phoneInput = { description: '_richContent' };
const _productCheckboxGroup = {
    description: '_richContent',
    options: '_productCheckboxGroupOption',
};
const _productCheckboxGroupOption = { media: '_mediaItem' };
const _propertiesType = { array: '_arrayType' };
const _querySubmissionRequest = {};
const _querySubmissionResponse = {};
const _querySubmissionsByNamespaceForExportRequest = {};
const _querySubmissionsByNamespaceForExportResponse = {};
const _querySubmissionsByNamespaceRequest = {};
const _querySubmissionsByNamespaceResponse = {};
const _radioGroup = { description: '_richContent' };
const _ratingInput = { description: '_richContent' };
const _removeSubmissionFromTrashBinRequest = {};
const _removeSubmissionFromTrashBinResponse = {};
const _restoreSubmissionFromTrashBinRequest = {};
const _restoreSubmissionFromTrashBinResponse = {};
const _richContent = { nodes: '_node' };
const _richText = { content: '_richContent' };
const _searchSubmissionsByNamespaceForExportRequest = {};
const _searchSubmissionsByNamespaceForExportResponse = {};
const _searchSubmissionsByNamespaceRequest = {};
const _searchSubmissionsByNamespaceResponse = {};
const _signature = { description: '_richContent' };
const _step = { layout: '_formLayout' };
const _submitButton = { thankYouMessage: '_thankYouMessage' };
const _submitSettings = { thankYouMessageOptions: '_thankYouMessageOptions' };
const _textInput = { description: '_richContent' };
const _thankYouMessage = { text: '_richContent' };
const _thankYouMessageOptions = { richContent: '_richContent' };
const _updateSubmissionRequest = {};
const _updateSubmissionResponse = {};
const _upsertContactFromSubmissionRequest = {};
const _upsertContactFromSubmissionResponse = {};
const _validation = { array: '_arrayType', object: '_objectType' };
const _wixFile = {
    fileUploadOptions: '_fileUpload',
    signatureOptions: '_signature',
};
/**
 * Create checkout from submission.
 * @internal
 * @documentationMaturity preview
 * @requiredField options.submission.submissions
 * @adminMethod
 */
export function createCheckoutFromSubmission(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submission: '$[0].submission',
            form: '$[0].form',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createCheckoutFromSubmissionRequest,
            depSchemas: {
                __Array,
                __Boolean,
                __Number,
                __Object,
                __String,
                _arrayItems,
                _arrayType,
                _arrayTypeArrayItems,
                _breakPoint,
                _checkbox,
                _checkboxGroup,
                _dateTimeInput,
                _displayField,
                _donationInput,
                _dropdown,
                _fileUpload,
                _form,
                _formField,
                _formFieldV2,
                _formLayout,
                _group,
                _header,
                _inputField,
                _inputFieldArrayType,
                _inputFieldMultilineAddress,
                _inputFieldObjectType,
                _itemLayout,
                _mediaItem,
                _multilineAddress,
                _nestedForm,
                _node,
                _numberInput,
                _objectType,
                _objectTypePropertiesType,
                _option,
                _payment,
                _phoneInput,
                _productCheckboxGroup,
                _productCheckboxGroupOption,
                _propertiesType,
                _radioGroup,
                _ratingInput,
                _richContent,
                _richText,
                _signature,
                _step,
                _submitButton,
                _submitSettings,
                _textInput,
                _thankYouMessage,
                _thankYouMessageOptions,
                _validation,
                _wixFile,
            },
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createCheckoutFromSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixFormsV4Submission.createCheckoutFromSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Is payment form submittable (ecom platform is installed and site is published).
 * @public
 * @documentationMaturity preview
 */
export function isFormSubmittable() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _isFormSubmittableRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _isFormSubmittableResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixFormsV4Submission.isFormSubmittable(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a submission.
 *
 *
 * The `createSubmission()` function is an alternative way to the [`WixFormsV2`](https://www.wix.com/velo/reference/$w/wixformsv2/submit) element for submitting a form. In this case, clicking the submit button is unnecessary, the submission is automatically created when calling this function.
 * @param submission - Submission to create.
 * @public
 * @requiredField submission
 * @requiredField submission.formId
 * @param options - Optional fields.
 */
export function createSubmission(submission, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submission: '$[0]',
            captchaToken: '$[1].captchaToken',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submission, options]);
        const reqOpts = ambassadorWixFormsV4Submission.createSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submission',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a new submission with specified submitter for a given form.
 * Internal, migration only.
 * @param submission - Submission to create.
 * @internal
 * @documentationMaturity preview
 * @requiredField submission
 * @requiredField submission.formId
 * @requiredField submission.submitter
 * @adminMethod
 * @returns The created submission.
 */
export function createSubmissionBySubmitter(submission, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submission: '$[0]',
            repeatedCreation: '$[1].repeatedCreation',
            lenientValidation: '$[1].lenientValidation',
        };
        const responseTransformation = '$.submission';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createSubmissionBySubmitterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createSubmissionBySubmitterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submission, options]);
        const reqOpts = ambassadorWixFormsV4Submission.createSubmissionBySubmitter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submission',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates multiple submissions with specified submitters.
 * Internal, migration only.
 * @param formId - Form id. Restricts submissions creation for a single form.
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @requiredField options.submissions.submissions
 * @requiredField options.submissions.submitter
 * @adminMethod
 */
export function bulkCreateSubmissionBySubmitter(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            submissions: '$[1].submissions',
            returnEntity: '$[1].returnEntity',
            submissionsV2: '$[1].submissionsV2',
            lenientValidation: '$[1].lenientValidation',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkCreateSubmissionBySubmitterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#submissions', 'Array#submissionsV2.submission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkCreateSubmissionBySubmitterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4Submission.bulkCreateSubmissionBySubmitter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a submission by ID.
 * @param submissionId - ID of the submission to retrieve.
 * @public
 * @requiredField submissionId
 * @adminMethod
 */
export function getSubmission(submissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId]);
        const reqOpts = ambassadorWixFormsV4Submission.getSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a submission by checkout ID.
 * @param checkoutId - Checkout ID of the submission to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField checkoutId
 * @adminMethod
 * @returns The retrieved submission.
 */
export function getSubmissionByCheckoutId(checkoutId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { checkoutId: '$[0]' };
        const responseTransformation = '$.submission';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSubmissionByCheckoutIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSubmissionByCheckoutIdResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([checkoutId]);
        const reqOpts = ambassadorWixFormsV4Submission.getSubmissionByCheckoutId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'checkoutId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a submission.
 *
 *
 * Each time the submission is updated, `revision` increments by 1. The existing `revision` must be included when updating the submission. This ensures you're working with the latest submission information, and prevents unintended overwrites.
 * @param _id - Submission ID.
 * @public
 * @requiredField _id
 * @requiredField submission
 * @requiredField submission.formId
 * @requiredField submission.revision
 * @param submission - Submission to update.
 * @adminMethod
 * @returns The updated submission.
 */
export function updateSubmission(_id, submission, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submission: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.submission';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, submission, options]);
        const reqOpts = ambassadorWixFormsV4Submission.updateSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'submission',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Confirms a submission.
 *
 *
 * You can only confirm a submission that has a `PENDING` status.
 * When using forms from the [Wix Pricing Plans](https://www.wix.com/app-market/paid-plans?referral=collection&appIndex=42&referralTag=made-by-wix&referralSectionName=made-by-wix) app, the default submission status is `PENDING`.
 * When using forms from the [Wix Forms]() app, the default form submission status is `CONFIRMED`. You can change the default status for individual submissions using the `updateSubmission()` method.
 * @param submissionId - Submission ID to confirm.
 * @public
 * @requiredField submissionId
 * @adminMethod
 */
export function confirmSubmission(submissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _confirmSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _confirmSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId]);
        const reqOpts = ambassadorWixFormsV4Submission.confirmSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a submission.
 *
 *
 * This function moves the form submission into the trash bin. To delete the submission permanently, change the default `permanent` field value to `true.`
 * @param submissionId - ID of the submission to delete.
 * @public
 * @requiredField submissionId
 * @param options - Optional fields.
 * @adminMethod
 */
export function deleteSubmission(submissionId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submissionId: '$[0]',
            permanent: '$[1].permanent',
            preserveFiles: '$[1].preserveFiles',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId, options]);
        const reqOpts = ambassadorWixFormsV4Submission.deleteSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes submissions by IDS for specific form.
 * @param formId - Form ID.
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @adminMethod
 */
export function bulkDeleteSubmission(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            submissionIds: '$[1].submissionIds',
            permanent: '$[1].permanent',
            preserveFiles: '$[1].preserveFiles',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4Submission.bulkDeleteSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Restores deleted submission
 * @param submissionId - ID of the submission to restore.
 * @public
 * @documentationMaturity preview
 * @requiredField submissionId
 * @adminMethod
 */
export function restoreSubmissionFromTrashBin(submissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _restoreSubmissionFromTrashBinRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _restoreSubmissionFromTrashBinResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId]);
        const reqOpts = ambassadorWixFormsV4Submission.restoreSubmissionFromTrashBin(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Remove deleted submission
 * @param submissionId - ID of the submission to restore.
 * @public
 * @documentationMaturity preview
 * @requiredField submissionId
 * @adminMethod
 */
export function removeSubmissionFromTrashBin(submissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _removeSubmissionFromTrashBinRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _removeSubmissionFromTrashBinResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId]);
        const reqOpts = ambassadorWixFormsV4Submission.removeSubmissionFromTrashBin(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Remove multiple deleted submissions
 * @param formId - Form ID.
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @adminMethod
 */
export function bulkRemoveSubmissionFromTrashBin(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            submissionIds: '$[1].submissionIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkRemoveSubmissionFromTrashBinRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkRemoveSubmissionFromTrashBinResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4Submission.bulkRemoveSubmissionFromTrashBin(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * List deleted submissions
 * @param formId - Form ID.
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @adminMethod
 */
export function listDeletedSubmissions(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            submissionIds: '$[1].submissionIds',
            paging: '$[1].paging',
            statuses: '$[1].statuses',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listDeletedSubmissionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listDeletedSubmissionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#submissions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4Submission.listDeletedSubmissions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get deleted submission
 * @param submissionId - Submission id.
 * @public
 * @documentationMaturity preview
 * @requiredField submissionId
 * @adminMethod
 */
export function getDeletedSubmission(submissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getDeletedSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getDeletedSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['submission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId]);
        const reqOpts = ambassadorWixFormsV4Submission.getDeletedSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deprecated on '2023-08-08'. Use QuerySubmissionsByNamespace.
 * @param query - Query options.
 * @public
 * @documentationMaturity preview
 * @requiredField query
 * @adminMethod
 * @deprecated
 * @replacedBy com.wixpress.forms.v4.FormSubmissionService.QuerySubmissionsByNamespace
 * @targetRemovalDate 2025-01-11
 */
export function querySubmission(query, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            query: '$[0]',
            onlyOwn: '$[1].onlyOwn',
            onlyYourOwn: '$[1].onlyYourOwn',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _querySubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _querySubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#submissions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([query, options]);
        const reqOpts = ambassadorWixFormsV4Submission.querySubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'query',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 *
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-forms/form-submissions/sort-and-filter).option
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @param search - Query options.
 * @public
 * @documentationMaturity preview
 * @requiredField search
 * @adminMethod
 */
export function searchSubmissionsByNamespace(search) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { search: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchSubmissionsByNamespaceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchSubmissionsByNamespaceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#submissions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([search]);
        const reqOpts = ambassadorWixFormsV4Submission.searchSubmissionsByNamespace(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'search',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 *
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-forms/form-submissions/sort-and-filter).option
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @param query - Query options.
 * @internal
 * @documentationMaturity preview
 * @requiredField query
 * @adminMethod
 */
export function searchSubmissionsByNamespaceForExport(query) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchSubmissionsByNamespaceForExportRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchSubmissionsByNamespaceForExportResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#submissions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([query]);
        const reqOpts = ambassadorWixFormsV4Submission.searchSubmissionsByNamespaceForExport(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'query',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of submissions.
 *
 *
 * The `querySubmissionsByNamespace()` method builds a query to retrieve a list of submissions from the specified namespace and returns a [`SubmissionsQueryBuilder`](#submissionsquerybuilder) object.
 * >**Note:** You can only query submissions from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * The returned object contains the query definition, which is typically used to run the query using the [`find()`](#submissionsquerybuilder/find) method.
 *
 * You can refine the query by chaining `SubmissionsQueryBuilder` methods onto the query. `SubmissionsQueryBuilder` methods enable you to sort, filter, and control the results that `querySubmissionsByNamespace()` returns.
 *
 * The following `SubmissionsQueryBuilder` methods are supported for `querySubmissionsByNamespace()`. For a full description of the Submissions object, see the object returned for the [`items`](#submissionsqueryresult/items) property in [`SubmissionsQueryResult`](#submissionsqueryresult).
 * @public
 * @param options - Query options.
 * @permissionId WIX_FORMS.SUBMISSION_READ_ANY
 * @adminMethod
 */
export function querySubmissionsByNamespace(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.submissions',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _querySubmissionsByNamespaceRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _querySubmissionsByNamespaceResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#submissions']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixFormsV4Submission.querySubmissionsByNamespace(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions for export from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-forms/form-submissions/sort-and-filter).option
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @param query - Query options.
 * @internal
 * @documentationMaturity preview
 * @requiredField query
 * @adminMethod
 */
export function querySubmissionsByNamespaceForExport(query) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _querySubmissionsByNamespaceForExportRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _querySubmissionsByNamespaceForExportResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#submissions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([query]);
        const reqOpts = ambassadorWixFormsV4Submission.querySubmissionsByNamespaceForExport(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'query',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Counts the number of submissions belonging to forms that were filtered and contain a provided expression.
 * @param filter - A filter object. Must filter by namespace.
 * @public
 * @documentationMaturity preview
 * @requiredField filter
 * @adminMethod
 */
export function countSubmissionsByFilter(filter, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0]', search: '$[1].search' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countSubmissionsByFilterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countSubmissionsByFilterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter, options]);
        const reqOpts = ambassadorWixFormsV4Submission.countSubmissionsByFilter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Counts the number of submissions belonging to the specified forms.
 *
 *
 * The `countSubmissions()` function is useful for analytics and tracking purposes. For example, if you have a contact form on your website, you can use this function to track how many submissions it receives daily, weekly, or monthly.
 * @public
 * @requiredField formIds
 * @requiredField namespace
 * @param namespace - The app which the form submissions belong to. For example, the namespace for the Wix Forms app is `wix.form_app.form`. Call `getSubmission()` to retrieve the namespace.
 * @param formIds - Form IDs which submissions should be counted.
 * @adminMethod
 */
export function countSubmissions(formIds, namespace, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formIds: '$[0]',
            namespace: '$[1]',
            statuses: '$[2].statuses',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countSubmissionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countSubmissionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formIds, namespace, options]);
        const reqOpts = ambassadorWixFormsV4Submission.countSubmissions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formIds',
                'namespace',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:**
 * > The Submissions API is only available in the Wix Studio editor.
 *
 * Counts the number of submissions belonging to the specified forms.
 * @param formIds - Form IDs.
 * @param namespace - Identifies the app which the form submissions belong to. For example, the namespace for the Wix Forms App is `"wix.form_app.form"`. The namespace of a submission can be retrieved using the Get Submission endpoint.
 * @public
 * @documentationMaturity preview
 * @requiredField formIds
 * @requiredField namespace
 * @adminMethod
 */
export function countDeletedSubmissions(formIds, namespace, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formIds: '$[0]',
            namespace: '$[1]',
            statuses: '$[2].statuses',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countDeletedSubmissionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countDeletedSubmissionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formIds, namespace, options]);
        const reqOpts = ambassadorWixFormsV4Submission.countDeletedSubmissions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formIds',
                'namespace',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a URL generated by the [Media Manager](https://www.wix.com/velo/reference/wix-media-v2/files/generatefileuploadurl) to use when creating a submission that includes a field for uploading files.
 * > **Note:** You need at least a [Standard Premium](https://support.wix.com/en/article/choosing-a-premium-plan) plan for your site to upload files.
 *
 *
 * To learn how external clients can use the generated upload URL to upload a file to the Media Manager, see [Upload API](https://www.wix.com/velo/reference/wix-media-v2/files/upload-api).
 * @param formId - Form ID.
 * @param filename - Name of file to upload.
 * @param mimeType - [Mime type](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#) of file to upload.
 *
 * For example, `'image/png'`
 * @public
 * @requiredField filename
 * @requiredField formId
 * @requiredField mimeType
 */
export function getMediaUploadUrl(formId, filename, mimeType) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            filename: '$[1]',
            mimeType: '$[2]',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getMediaUploadURLRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getMediaUploadURLResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, filename, mimeType]);
        const reqOpts = ambassadorWixFormsV4Submission.getMediaUploadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'filename',
                'mimeType',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Marks form submissions as "seen".
 *
 *
 * This function marks the submissions as if they were seen by the site owner. Only site collaborators with the **[Manage Submission](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions)** permissions can mark submissions.
 * @public
 * @requiredField formId
 * @requiredField ids
 * @param ids - IDs of submissions to mark as seen.
 * @param formId - ID of the form which the submissions belong to.
 * @adminMethod
 */
export function bulkMarkSubmissionsAsSeen(ids, formId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { ids: '$[0]', formId: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkMarkSubmissionsAsSeenRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkMarkSubmissionsAsSeenResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([ids, formId]);
        const reqOpts = ambassadorWixFormsV4Submission.bulkMarkSubmissionsAsSeen(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'ids',
                'formId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Upserts contact from submission.
 * @param submissionId - Submission from which contact needs to be upserted.
 * @public
 * @documentationMaturity preview
 * @requiredField submissionId
 * @adminMethod
 */
export function upsertContactFromSubmission(submissionId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submissionId: '$[0]',
            contactId: '$[1].contactId',
            emailVerified: '$[1].emailVerified',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _upsertContactFromSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _upsertContactFromSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId, options]);
        const reqOpts = ambassadorWixFormsV4Submission.upsertContactFromSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=forms-v4-submission.universal.js.map